export const getDevice = function () {
  if (navigator.userAgent.match(/Android/i)) {
    return "ANDROID";
  } else if (navigator.userAgent.match(/iPhone/i)) {
    return "IPHONE";
  } else if (navigator.userAgent.match(/iPad/i)) {
    return "IPAD";
  } else if (navigator.userAgent.match(/iPod/i)) {
    return "IPOD";
  } else if (navigator.userAgent.match(/BlackBerry/i)) {
    return "BLACKBERRY";
  } else if (navigator.userAgent.match(/Windows Phone/i)) {
    return "WINDOWSPHONE";
  } else {
    return "DESKTOP";
  }
};

export const getBrowser = function () {
  if (
    (navigator.userAgent.indexOf("Opera") ||
      navigator.userAgent.indexOf("OPR")) !== -1
  ) {
    return "OPERA";
  } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
    return "CHROME";
  } else if (navigator.userAgent.indexOf("Safari") !== -1) {
    return "SAFARI";
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    return "FIREFOX";
  } else if (
    navigator.userAgent.indexOf("MSIE") !== -1 ||
    !!document.documentMode === true
  ) {
    return "IE";
  } else {
    return "";
  }
};

export const SOCIAL_TYPES = {
  facebook: "FB",
  twitter: "TW",
  linkedin: "IN",
  windows: "HOTMAIL",
  google: "GOOGLE",
};

export const REGEX = {
  email:
    /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-zA-Z]{2,})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,
  alphabets: /^[A-Za-z\- ]+$/i,
};

export const stringLength = function (string, length) {
  if (!length) {
    length = 8;
  }

  return string.length >= length;
};

export const isEmail = function (email) {
  return (
    email.trim(" ").length && REGEX.email.test(String(email).toLowerCase())
  );
};

export const isAlphabets = function (string) {
  return REGEX.alphabets.test(string);
};

export const isExpiredDateTime = function (dateTime) {
  let isExpired = true;
  if (dateTime) {
    isExpired = Date.parse(dateTime) < Date.parse(new Date());
  }
  return isExpired;
};

// ---------------------------------------------------------------------------
// Safe web-storage access — ClickUp 86ex9ujxc
//
// Reading window.localStorage THROWS rather than returning null when the
// browser has blocked storage: a sandboxed iframe, an enterprise policy, or
// partitioned third-party storage. Clarity reports 26 of
// "Failed to read the 'localStorage' property from 'Window': Access is denied"
// a month, sitewide.
//
// The count understates it. The first of these calls is in the IIFE at the top
// of local.js, which runs on every login and signup page load — an unguarded
// throw there aborts the module's top-level code, so none of the form handlers
// below it are ever wired up and the page is dead for that visitor.
//
// Every helper degrades to "no stored value" and never throws.
// ---------------------------------------------------------------------------
const withStore = function (kind, action, fallback) {
  try {
    const store = window[kind];
    if (!store) {
      return fallback;
    }
    return action(store);
  } catch (ex) {
    return fallback;
  }
};

// Some callers need the storage OBJECT rather than a single value - the
// signup-attribution helpers take a `storage` argument and do their own
// try/catch around every access. Passing the bare `localStorage` identifier to
// them is what this file exists to prevent: the property read throws at the
// CALL SITE, before the helper is entered, so its internal try/catch never
// runs. These return the object, or null when storage is blocked; the
// attribution helpers already treat a null storage as "no stored value"
// because every access inside them is guarded.
export const getLocalStorage = function () {
  return withStore("localStorage", (store) => store, null);
};

export const getSessionStorage = function () {
  return withStore("sessionStorage", (store) => store, null);
};

export const getLocalItem = function (key) {
  return withStore("localStorage", (store) => store.getItem(key), null);
};

export const setLocalItem = function (key, value) {
  return withStore(
    "localStorage",
    (store) => {
      store.setItem(key, value);
      return true;
    },
    false,
  );
};

export const removeLocalItem = function (key) {
  return withStore(
    "localStorage",
    (store) => {
      store.removeItem(key);
      return true;
    },
    false,
  );
};

export const getSessionItem = function (key) {
  return withStore("sessionStorage", (store) => store.getItem(key), null);
};

export const setSessionItem = function (key, value) {
  return withStore(
    "sessionStorage",
    (store) => {
      store.setItem(key, value);
      return true;
    },
    false,
  );
};

export const removeSessionItem = function (key) {
  return withStore(
    "sessionStorage",
    (store) => {
      store.removeItem(key);
      return true;
    },
    false,
  );
};
